import {
  ADICIONAR_TIPOS_PROCESSO,
  ADICIONAR_TIPOS_REQUERENTE,
  ADICIONAR_INFRACAO,
  ATUALIZAR_PROCESSO,
  ATUALIZAR_REQUERENTE,
  ADICIONAR_BANCOS,
  ADICIONAR_TIPOS_CONTA,
  DETALHAR_PROCESSO,
  LIMPAR_PROCESSO,
  ADICIONAR_RESPONSAVEIS,
  ADICIONAR_SITUACOES,
  ADICIONAR_ALEGACOES
} from "./actions";


const initialState = {
  infracao: {},
  processo: {},
  requerente: {},
  responsaveis: [],
  situacoes: [],
  alegacoes: [],
  tiposProcesso: [],
  tiposRequerente: [],
  bancos: [],
  tiposConta: [],
  processoDetalhe: {},
  processoEditado: {}
}

export default (state = initialState, action) => {
  switch (action.type) {
    case ADICIONAR_INFRACAO:
      return { ...state, infracao: { ...state.infracao, ...action.infracao } };
    case ADICIONAR_BANCOS:
      return { ...state, bancos: [...action.bancos] };
    case ADICIONAR_TIPOS_CONTA:
      return { ...state, tiposConta: [...action.tiposConta] };
    case ADICIONAR_TIPOS_PROCESSO:
      return { ...state, tiposProcesso: [...action.tiposProcesso] };
    case ADICIONAR_RESPONSAVEIS:
      return { ...state, responsaveis: [...action.responsaveis] };
    case ADICIONAR_SITUACOES:
      return { ...state, situacoes: [...action.situacoes] };
    case ADICIONAR_ALEGACOES:
      return { ...state, alegacoes: [...action.alegacoes] };
    case ADICIONAR_TIPOS_REQUERENTE:
      return { ...state, tiposRequerente: [...action.tiposRequerente] };
    case ATUALIZAR_PROCESSO:
      return { ...state, processo: { ...state.processo, ...action.processo } };
    case LIMPAR_PROCESSO:
      return { ...state, processo: {}, requerente: {}, infracao: {} };
    case ATUALIZAR_REQUERENTE:
      return { ...state, requerente: { ...state.requerente, ...action.requerente } };
    case DETALHAR_PROCESSO:
      return { ...state, processoDetalhe: action.processo };

    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/paginas/processo/reducers.js